import { fetchDelayCertificates, loadedDelayCertificates } from '../actions'
import { connect } from 'react-redux'
import { showAlert } from '../utils/Alert'
import DelayCertificateApp from '../components/delay_certificates/DelayCertificateApp'

const mapStateToProps = (state, _props) => {
  return {
    delayCertificates: state.delayCertificateReducer.delayCertificates,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchDelayCertificates: async () => {
      try {
        const payload = await fetchDelayCertificates()
        dispatch(loadedDelayCertificates(payload))
      } catch (error) {
        showAlert("遅延証明書が取得できませんでした")
      }
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DelayCertificateApp)